import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("authToken"));
  const [userName, setUserName] = useState(
    localStorage.getItem("authUserName"),
  );

  const [isAuthenticated, setIsAuthenticated] = useState(
    sessionStorage.getItem("isAuthenticated") === "true",
  );

  const [loading, setLoading] = useState(true);

  const login = (newToken, name, id) => {
    localStorage.setItem("authToken", newToken);
    localStorage.setItem("authUserName", name);
    localStorage.setItem("authUserId", id);

    sessionStorage.setItem("isAuthenticated", "true");

    localStorage.removeItem("guest_token");

    setToken(newToken);
    setUserName(name);
    setIsAuthenticated(true);
  };

  const logout = async () => {
    const currentToken = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        "https://tyka.premierhostings.com/beta/api/logout/me",
        {},
        {
          headers: {
            Authorization: `Bearer ${currentToken}`,
          },
        },
      );
      if (response.data?.success === true) {
        toast.success(response.data?.message || "Logout successful");
        window.location.href = "/";
      } else {
        toast.error(response.data?.message || "Logout failed");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Something went wrong during logout",
      );
    } finally {
      localStorage.removeItem("authToken");
      localStorage.removeItem("authUserName");
      localStorage.removeItem("authUserId");
      localStorage.removeItem("guest_token");

      sessionStorage.setItem("isAuthenticated", "false");

      setToken(null);
      setUserName(null);
      setIsAuthenticated(false);

      // setTimeout(() => {
      //   window.location.href = "/";
      // }, 500);
    }
  };

  // Check token when app loads / refreshes
  useEffect(() => {
    const checkToken = async () => {
      const savedToken = localStorage.getItem("authToken");
      const authUserId = localStorage.getItem("authUserId");
      const savedName = localStorage.getItem("authUserName");

      if (!savedToken || !authUserId) {
        setIsAuthenticated(false);
        sessionStorage.setItem("isAuthenticated", "false");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `https://tyka.premierhostings.com/beta/api/users/${authUserId}`,
          {
            headers: {
              Authorization: `Bearer ${savedToken}`,
            },
          },
        );

        if (response.data?.success === true) {
          // Token valid
          setToken(savedToken);

          // Set username from localStorage
          setUserName(savedName);

          setIsAuthenticated(true);
          sessionStorage.setItem("isAuthenticated", "true");
        } else {
          // Token invalid
          setIsAuthenticated(false);
          sessionStorage.setItem("isAuthenticated", "false");

          localStorage.removeItem("authToken");
          localStorage.removeItem("authUserName");
          localStorage.removeItem("authUserId");

          setUserName(null);
        }
      } catch (error) {
        if (error.response?.status === 401) {
          setIsAuthenticated(false);
          sessionStorage.setItem("isAuthenticated", "false");

          localStorage.removeItem("authToken");
          localStorage.removeItem("authUserName");
          localStorage.removeItem("authUserId");

          setToken(null);
          setUserName(null);

          toast.error(
            error.response?.data?.message ||
              "Session expired. Please login again.",
          );
          window.location.href = "/";
        }
      } finally {
        setLoading(false);
      }
    };

    checkToken();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        token,
        userName,
        isAuthenticated,
        loading,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
